import { Divider, Snackbar, Typography } from "@material-ui/core";
import React, { useState } from "react";
import "./SectionTile.css";
import TouchRipple from "@material-ui/core/ButtonBase/ButtonBase";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { fullscreenWindow } from "../../utils/utils";
import { Alert } from "@material-ui/lab";

const SectionTile = ({ title, task, description, section, disabled, setDisabled, sectionD }) => {
	const history = useHistory();

	const [alreadyAttempted, setAlreadyAttempted] = useState(false);

	const handleClick = async () => {
		if (disabled) {
			return;
		}

		setDisabled(true);

		// let block = false;
		const token = localStorage.getItem("token");

		// if (sectionD) {
		// 	const attemptUrl = `${process.env.REACT_APP_BACKEND_URL}/attempt/sectionD`;

		// 	try {
		// 		await axios
		// 			.get(attemptUrl, {
		// 				headers: {
		// 					Authorization: `Bearer ${token}`,
		// 				},
		// 			})
		// 			.then((res) => {
		// 				if (res.data.alreadyAttempted) {
		// 					block = true;
		// 				}
		// 			});
		// 	} catch (error) {
		// 		// console.log(error.response.data);
		// 		if (error.response.data.alreadyAttempted) {
		// 			block = true;
		// 		}
		// 	}
		// }

		// if (block) {
		// 	setAlreadyAttempted(true);
		// 	setDisabled(false);
		// 	return;
		// }

		const url = sectionD
			? `${process.env.REACT_APP_BACKEND_URL}/sectionD/all`
			: `${process.env.REACT_APP_BACKEND_URL}/attempt/section/${section}`;

		const redirect = sectionD ? `/test/sectionD` : `/test/section/${section}`;

		try {
			await axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then((res) => {
					// console.log(res);
					setDisabled(false);
					fullscreenWindow();

					history.push({
						pathname: redirect,
						state: { data: res.data },
					});
				});
		} catch (error) {
			// console.log(error);
			setDisabled(false);
			setAlreadyAttempted(true);
		}
	};

	return (
		<>
			<TouchRipple className="section-tile" onClick={handleClick}>
				<Typography variant="h4" className="section-title">
					{title}
				</Typography>
				<Divider className="tile-divider" />
				<Typography variant="body1" style={{ fontSize: "1.3rem" }}>
					{task}
				</Typography>
				<Typography variant="body1" style={{ fontSize: "1.2rem" }}>
					{description}
				</Typography>
			</TouchRipple>
			<Snackbar
				open={alreadyAttempted}
				onClose={() => setAlreadyAttempted(false)}
				autoHideDuration={3000}
			>
				<Alert severity="error" variant="filled" onClose={() => setAlreadyAttempted(false)}>
					Please try again
				</Alert>
			</Snackbar>
		</>
	);
};

export default SectionTile;
